import React, {useEffect} from 'react';
import {Box, Button, Table, TableBody, TableHead, TablePagination} from "@mui/material";
import {StyledTableCell, StyledTableRow} from '../common/table/TableStyles';
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import Typography from "@mui/material/Typography";
import {useTypedSelector} from "../../store";
import {useLazyGetDoctorsQuery} from "../../store/rtk-api/doctor/doctor";
import IsError from "../common/IsError";
import {useNavigate} from "react-router-dom";
import {IDoctorsResponse} from "../../store/rtk-api/doctor/types";

type Props = {
    rowsPerPage: number,


}

const mapping = {
    'doctorName': 'Врач',
    'speciality': 'Специальности/Процедуры',
    'isPosted': 'Опубликован',
    'Edit': 'Редактировать',

}

const DoctorTable: React.FC<Props> = ({rowsPerPage}) => {
    const navigate = useNavigate()
    const {...filterData} = useTypedSelector(state => state.doctor)
    const [getDoctors, {data: doctors2, isError, isLoading}] = useLazyGetDoctorsQuery()
    const {addressId} = useTypedSelector(state => state.header)

    useEffect(() => {
        getDoctors({...filterData, id: addressId})
    }, [filterData.query, filterData.is_active, filterData.page, addressId])

    const doctors = {
        count: 2,
        next: null,
        previous: null,
        results: [
            {
                doctor_address: "123 Main St, Anytown, USA",
                first_name: "John",
                id: 1,
                is_active: true,
                last_name: "Doe",
                middle_name: "A",
                photo: "https://example.com/photos/johndoe.jpg",
                procedures: "General check-up, Blood test, Vaccination",
                specialities: "General Practitioner, Family Medicine"
            },
            {
                doctor_address: "456 Elm St, Othertown, USA",
                first_name: "Jane",
                id: 2,
                is_active: true,
                last_name: "Smith",
                middle_name: "B",
                photo: "https://example.com/photos/janesmith.jpg",
                procedures: "Pediatric check-up, Immunization, Growth monitoring",
                specialities: "Pediatrics"
            }
        ]
    };


    return (
        <>
            <IsError isError={isError}/>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {Object.values(mapping).map((title, idx) => {
                            return (
                                <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                            )
                        })}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {isLoading ?
                        <TableLoadingMockup cellCount={6} rowCount={rowsPerPage}/>
                        :
                        doctors?.results?.map((item, ind) => (
                            <StyledTableRow key={item.id}>
                                <StyledTableCell>
                                    <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <img style={{
                                            borderRadius: "50px",
                                            height: "40px",
                                            width: "40px"
                                        }}
                                             src={item.photo}

                                        />
                                        <Typography>{`${item.last_name} ${item.first_name.slice(0, 1)}. ${item.middle_name.slice(0, 1)}.`}</Typography>
                                    </Box>

                                </StyledTableCell>
                                <StyledTableCell>{item.specialities}</StyledTableCell>
                                {item?.doctor_address ? <StyledTableCell>Да</StyledTableCell> :
                                    <StyledTableCell>Нет</StyledTableCell>}
                                <StyledTableCell>
                                    <Button variant={"outlined"} sx={{
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        border: "1px solid #666666",
                                        color: "#666666",
                                        textTransform: "capitalize"
                                    }}
                                            onClick={() => navigate('one', {
                                                state: {
                                                    doctorId: item.id
                                                }
                                            })}>Редактировать</Button>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                </TableBody>
            </Table>
        </>
    );
};

export default DoctorTable;
